import Loadable from "react-loadable";

const LazyLivrable = Loadable({
  loader: () => import(/* webpackChunkName: 'livrable-validation' */ "./validation"),
  loading: () => 'loading...'
});

export default LazyLivrable;
